import { useContext, Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { AspectRatio } from './AspectRatio';
import { AuthenticationContext } from '../msal/AuthenticationContext';

import css from './LoginScreen.module.scss';
import sharedCss from '../pages/Shared.module.scss';

class LoginScreenInternal extends Component {
    login = () => {
        this.props.authenticationContext.login(window.location.pathname)
    }

    render() {

        return <div className={sharedCss.background}>
            <Container fluid={true}>
                <div className="d-flex">
                    <div className="p-4">
                        <img className={sharedCss.logo} src="./images/TeresaCare-Logo.png" alt="TeresaCare logo"/>
                    </div>                    
                </div>

                <div className="bg-dark d-flex flex-row-reverse p-3">
                    <Button color='primary' onClick={this.login}>Login</Button>                        
                </div>
            
                <AspectRatio className={css.topImageContainer} aspectRatio="1:0.21">
                    <img src="./images/hospital-corridor.jpg" alt="" />                
                    <div className={css.overlayHeader}>
                        <p>TeresaCare Messenger Portal</p>
                    </div>
                </AspectRatio>   
            </Container>
            <Container>
                <div>
                    <p>Revision 1.13</p>
                </div>
            </Container>
            <Container fluid={true} className="bg-dark">
                <Container className={`text-white ${css.footerList}`}>
                    <Row>
                        <Col className="text-center">
                            <ul>
                                <li><h5>Contact information</h5></li>
                                <li>+31 72 534 64 26</li>
                                <li>info@teresacare.nl</li>
                            </ul>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center">
                            <p>
                            <span className="ms-1">
                                    © 2020-{(new Date().getFullYear())}{' '}
                                    <a href="https://teresacare.nl" target="_blank" rel="noopener noreferrer">
                                        TeresaCare
                                    </a>
                                </span>
                                <span>
                                    {' '}
                                    |
                                    <a href="https://teresacare.nl/disclaimer.html" target="_blank" rel="noopener noreferrer">
                                        <span className="ms-1">Disclaimer</span>
                                    </a>
                                </span>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>;
    }
}

// Wrap the component so that multiple contexts are available via the props.
export const LoginScreen = (props) => {
    const authenticationContext = useContext(AuthenticationContext);
  
    return (
        <LoginScreenInternal authenticationContext={authenticationContext} {...props}/>
    )
}